module.exports = __webpack_public_path__ + "img/BG.264df709.png";